<div
  data-testid="assign-roles-dialog-container"
  class="assign-roles-dialog p-4 flex flex-col gap-4 w-full overflow-x-hidden max-w-full"
>
  <nav class="flex border-b border-gray-200 -mb-px">
    <button
      data-testid="assign-roles-dialog-tab-roles"
      type="button"
      class="px-4 py-2 text-sm font-medium border-b-2 transition-colors"
      [class.border-blue-500]="activeTab() === 'roles'"
      [class.text-blue-600]="activeTab() === 'roles'"
      [class.border-transparent]="activeTab() !== 'roles'"
      [class.text-gray-500]="activeTab() !== 'roles'"
      (click)="setTab('roles')"
    >
      {{ "configuration.user_roles_assignment.dialog.tab_roles" | translate }}
    </button>
    <button
      data-testid="assign-roles-dialog-tab-business-unit"
      type="button"
      class="px-4 py-2 text-sm font-medium border-b-2 transition-colors"
      [class.border-blue-500]="activeTab() === 'bu'"
      [class.text-blue-600]="activeTab() === 'bu'"
      [class.border-transparent]="activeTab() !== 'bu'"
      [class.text-gray-500]="activeTab() !== 'bu'"
      (click)="setTab('bu')"
    >
      {{ "configuration.user_roles_assignment.dialog.tab_bu" | translate }}
    </button>
  </nav>

  @if (activeTab() === "roles") {
    <app-search-form
      data-testid="assign-roles-dialog-search-form"
      [searchFormat]="searchFormConfig"
      (formSearch)="onSearch($event)"
      (formReset)="onReset()"
    ></app-search-form>

    <div
      class="roles-table-section flex-1 min-h-0 w-full overflow-x-hidden min-w-0"
    >
      <h4 class="text-sm font-semibold text-gray-700 mb-2">
        {{
          "configuration.user_roles_assignment.dialog.select_roles" | translate
        }}
      </h4>
      <app-data-table
        data-testid="assign-roles-dialog-roles-table"
        [dataSource]="roles()"
        [columns]="columns"
        [loading]="loading()"
        [rows]="pageSize"
        [first]="first()"
        [totalRecords]="totalRecords()"
        [hasCheckColumn]="true"
        [selection]="selectedRoles()"
        [scrollHeight]="'300px'"
        [tableStyle]="{ width: '100%', minWidth: '0', tableLayout: 'fixed' }"
        (pageChange)="onPageChange($event)"
        (selectionChange)="onSelectionChange($event)"
        class="w-full assign-roles-table"
      >
      </app-data-table>
    </div>
  }

  @if (activeTab() === "bu") {
    <div
      class="bu-tree-section flex-1 min-h-0 w-full overflow-hidden flex flex-col"
    >
      <h4 class="text-sm font-semibold text-gray-700 mb-2">
        {{ "configuration.user_roles_assignment.dialog.select_bu" | translate }}
      </h4>
      @if (buLoading()) {
        <div class="flex items-center justify-center py-8 text-gray-500">
          {{ "common.table.loading" | translate }}
        </div>
      } @else {
        <div
          class="bu-tree-wrapper border border-gray-200 rounded-lg overflow-auto min-h-0 flex-1"
          style="max-height: 320px"
        >
          <p-tree
            data-testid="assign-roles-dialog-business-unit-tree"
            [value]="buTreeNodes()"
            selectionMode="single"
            [(selection)]="selectedBuNode"
            class="w-full"
          ></p-tree>
        </div>
      }
    </div>
  }

  <div class="flex justify-end gap-3 pt-4 border-t border-gray-200">
    <app-button
      [testId]="'assign-roles-dialog-cancel-btn'"
      [label]="'common.actions.cancel' | translate"
      type="secondary"
      [outlined]="true"
      (emitOnClick)="onCancel()"
    ></app-button>
    <app-button
      [testId]="'assign-roles-dialog-confirm-btn'"
      [label]="
        'configuration.user_roles_assignment.actions.assign_roles' | translate
      "
      type="info"
      [disabled]="!canConfirm()"
      (emitOnClick)="onConfirm()"
    ></app-button>
  </div>
</div>
